<script>
import Form from '@classes/Form'
import { authComputed, authMethods } from '@state/helpers'
import axios from 'axios'
import { userService } from '@/src/services/UserService'
import OtpInput from '@/src/components/otp-input.vue'

export default {
  components: { OtpInput },
  page: {
    title: 'Register',
    meta: [{ name: 'description', content: 'The Register page.' }],
  },
  data() {
    return {
      form: new Form({
        device_type: 'email',
      }),
      otpauth: null,
      tryingToRegister: false,
      enterCode: false,
      authError: null,
      userForm: new Form({
        first_name: '',
        last_name: '',
        gender: '',
        sex: '',
        credential: '',
        dob: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone_number: '',
        imperial_units: '',
        has_mfa_enabled: false,
      }),
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    async tryToRegister() {
      const self = this
      self.tryingToRegister = true

      const userData = JSON.parse(localStorage.getItem('userData'))
      userData.has_mfa_enabled = true
      this.userForm.first_name = userData.first_name
      this.userForm.last_name = userData.last_name
      this.userForm.gender = userData.gender.key
      this.userForm.sex = userData.sex.key
      this.userForm.credential = userData.credential || {}
      this.userForm.dob = userData.dob
      this.userForm.email = userData.email
      this.userForm.address = userData.address
      this.userForm.city = userData.city
      this.userForm.state = null
      this.userForm.zip = userData.zip_code
      this.userForm.phone_number = userData.phone_number || ''
      this.userForm.imperial_units = userData.imperial_units
      this.userForm.has_mfa_enabled = userData.has_mfa_enabled

      if (this.form.device_type === 'email') {
        try {
          const response = await axios.post('/api/v1/mfa/register/hotp/', {
            device_type: this.form.device_type,
          })
          if (response.status === 201) {
            // prepei na mpainei kai edw o serialized user sto store / na allazei to mfa_enabled se true
            self.tryingToRegister = false
            // await userService.update(this.serializedUser.user_id, userData)
            await userService.update(
              this.serializedUser.user_id,
              this.userForm.data()
            )
            const updatedUser = await this.addMfaDevice(response.data)
            if (updatedUser) {
              this.goBack()
            } else {
              throw new Error('Error in 2fa registration')
            }
          }
        } catch (error) {
          console.warn(error)
        }
      } else if (this.form.device_type === 'google') {
        try {
          const { data } = await axios.post('/api/v1/mfa/register/totp/', {
            device_type: this.form.device_type,
          })
          if (data) {
            self.tryingToRegister = false
            const updatedUser = await this.addMfaDevice(data)
            if (updatedUser) {
              this.$router.push({
                name: '2fa.qrgoogle',
                params: { uuid: data.uuid, value: data.provisioning_url },
              })
            }
          }
        } catch (error) {
          console.warn(error)
        }
      }
    },
    async verifyCode(code) {
      try {
        // 1. Make sure verification code is ok
        const verifyResponse = await axios.post('/api/v1/verify/', {
          code: code,
        })

        if (verifyResponse.status === 200) {
          // 2. Enable mfa
          const response = await userService.update(
            this.serializedUser.user_id,
            {
              has_mfa_enabled: true,
            }
          )
          const updatedUser = await this.addMfaDevice(response.data)
          if (updatedUser) {
            this.goBack()
          } else {
            throw new Error('Error in 2fa registration')
          }
        }
      } catch (error) {
        this.authError = error
        throw new Error(`Problem handling something: ${error}`)
      }
    },
    goBack() {
      this.$router.push({ name: 'safehaven-profile', params: { tabId: 3 } })
    },
  },
}
</script>

<template>
  <v-container class="d-flex justify-center" fluid>
    <div :class="$style.innerContainer">
      <v-row
        no-gutters
        :class="$style.title"
        class="offblack--text"
        justify="center"
      >
        2FA Registration
      </v-row>
      <v-row
        no-gutters
        :class="$style.subtitle"
        class="offblack--text"
        justify="center"
      >
        Please select your two-factor authentication type:
      </v-row>
      <form class="offblack--text" @submit.prevent="tryToRegister">
        <v-radio-group v-model="form.device_type" column>
          <v-radio value="email"
            ><template v-slot:label>
              <span class="offblack--text">Email</span>
            </template></v-radio
          >
        </v-radio-group>
        <v-row class="mt-11" no-gutters justify="space-between">
          <div
            class="my-auto ml-1 clickable primary--text"
            :class="$style.hrRouterLinkText"
            @click="goBack"
            ><v-icon color="primary">mdi-chevron-left</v-icon> Back</div
          >
          <v-btn
            width="112"
            height="56"
            rounded
            :disabled="form.errors.any()"
            type="submit"
            color="primary"
            :class="$style.hrButton"
            class="my-auto text-capitalize"
            :loading="tryingToRegister"
            >Register</v-btn
          >
        </v-row>

        <div v-if="enterCode" class="mt-5">
          <p>Please enter your verification code to proceed</p>
          <v-row justify="center">
            <OtpInput
              :class="authError ? $style.invalid : ''"
              @input="verifyCode"
            ></OtpInput>
          </v-row>
        </div>

        <v-row v-if="form.errors.any()" no-gutters justify="start">
          <p class="alert alert-danger mt-5" role="alert">
            There was an error registering 2fa.
          </p>
        </v-row>
      </form>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

/* The container */
.container {
  position: relative;
  display: block;
  padding-left: 35px;
  margin-bottom: 32px;
  font-size: 18px;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browswer's default radio button */
.container input {
  position: absolute;
  cursor: pointer;
  opacity: 0;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 25px;
  height: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark::after {
  position: absolute;
  display: none;
  content: '';
}

/* Show the indicator (dot/circle) */
.container .checkmark::after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}

.buttonRight {
  float: right;
}

.termsRow {
  position: absolute;
  right: 0;
  bottom: 10px;
  width: 100%;
}

.termsPrivacy {
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}

.innerContainer {
  max-width: 600px;
  margin-bottom: 250px;
}

.hrButton {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.75px;
  border-radius: 12px !important;
}

.title {
  margin-bottom: 25px !important;
  font-size: 32px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: 1px;
}

.subtitle {
  margin-bottom: 25px !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.25px;
}

.invalid {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

.hrRouterLinkText {
  font-family: $system-default-font-family;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}

/* also need keyframes and -moz-keyframes */
@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
